// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {WritingDirection} from './writing-direction.js'

export class SetWritingDirection {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetWritingDirection {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetWritingDirection(bb: flatbuffers.ByteBuffer, obj?: SetWritingDirection): SetWritingDirection {
    return (obj || new SetWritingDirection()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetWritingDirection(
    bb: flatbuffers.ByteBuffer,
    obj?: SetWritingDirection
  ): SetWritingDirection {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetWritingDirection()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): WritingDirection | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startSetWritingDirection(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: WritingDirection) {
    builder.addFieldInt8(0, value, null)
  }

  static endSetWritingDirection(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetWritingDirection(builder: flatbuffers.Builder, value: WritingDirection | null): flatbuffers.Offset {
    SetWritingDirection.startSetWritingDirection(builder)
    if (value !== null) SetWritingDirection.addValue(builder, value)
    return SetWritingDirection.endSetWritingDirection(builder)
  }
}
